import classNames from "classnames";
import { Icon, IconSize } from "PFComponents/icon";
import { Typography } from "PFComponents/typography";
import { getContrastingTextColor } from "PFCore/utilities/color";
import { validateCategoryIcon } from "PFModules/admin/booking/categories/booking_categories.utils";
import { IconName } from "PFTheme/graphics/icons";
import radii from "PFTheme/tokens/radii";
import { BookingCategory } from "PFTypes";
import React, { CSSProperties, PropsWithChildren } from "react";

import { BasicPill } from "./basic_pill";
import { getCategoryBorderColor, NO_CATEGORY_COLOR } from "./booking_pill.utils";
import css from "./pill.module.scss";

type BookingPillProps = PropsWithChildren<{
  category: BookingCategory | undefined;
  className?: string;
  style?: CSSProperties;
  withCategoryIcon?: boolean;
  withCategoryName?: boolean;
  iconSize?: IconSize;
  center?: boolean;
  title?: string;
}>;

export const BookingPill = ({
  children,
  className,
  style,
  category,
  withCategoryIcon = true,
  withCategoryName,
  iconSize,
  center
}: BookingPillProps) => {
  const isNoCategory = !category;
  const textColor = category ? getContrastingTextColor(category.color, 1).hex() : undefined;
  const finalStyle = isNoCategory
    ? { ...style, background: `var(--${NO_CATEGORY_COLOR})` }
    : {
        background: category.color,
        borderWidth: radii.radiusXs,
        borderColor: getCategoryBorderColor(category),
        borderStyle: "solid",
        color: textColor,
        ...style
      };
  const categoryIcon = isNoCategory ? ("locked" as IconName) : validateCategoryIcon(category.icon);

  return (
    <BasicPill
      className={classNames(css.bookingPill, className, { [css.center]: isNoCategory || !!center })}
      style={finalStyle}
    >
      {withCategoryIcon && !!categoryIcon && (
        <Icon name={categoryIcon} size={iconSize} fill={textColor} className={css.categoryIcon} />
      )}
      {!!withCategoryName && category && (
        <Typography variant="labelRegular" clipOverflow title={category?.display_as}>
          {category?.display_as}
        </Typography>
      )}
      {children}
    </BasicPill>
  );
};
